import React, { FC } from "react";
import { useStore } from "src/store";
import { SidebarWrapper } from "./wrapper/Sidebar.wrapper";
// import { SubLinkId } from "src/data";
import { Footprint } from "./contents/overview/Footprint";
import { SystemStatus } from "./contents/overview/System-status";
import { ValidationRegulatorySupport } from "./contents/overview/Validation-regulatory-support";
import { ApplicationSupport } from "./contents/overview/Application-support";
import { Scalabilty } from "./contents/flexibility/Scalabilty";
import { HollowFiberCartridges } from "./contents/flexibility/Hallow-fiber-cartridges";
import { Mixing } from "./contents/flexibility/Mixing";
import { Unicorn } from "./contents/automation/Unicorn";
import { OpcUa } from "./contents/automation/Opc_ua";
import { Pumps } from "./contents/process-control/Pumps";
import { Sensors } from "./contents/process-control/Sensors";
import { FlowPath } from "./contents/process-control/Flow-path";
import { FlatSheetCassettes } from "./contents/flexibility/Flat-sheet-cassettes";

// const Content: FC = (): JSX.Element => {
//   const { activeSubLink } = useStore();
//   switch (activeSubLink.id) {
//     case SubLinkId.footprint:
//       return <Footprint />;
//     case SubLinkId.system_status:
//       return <SystemStatus />;
//     case SubLinkId.validation_regulatory_support:
//       return <ValidationRegulatorySupport />;
//     case SubLinkId.application_support:
//       return <ApplicationSupport />;
//     case SubLinkId.scalabilty:
//       return <Scalabilty />;
//     case SubLinkId.hollow_fiber_cartridges:
//       return <HollowFiberCartridges />;
//     case SubLinkId.flat_sheet_cassettes:
//       return <FlatSheetCassettes />;
//     case SubLinkId.mixing:
//       return <Mixing />;
//     case SubLinkId.unicorn:
//       return <Unicorn />;
//     case SubLinkId.opc_ua:
//       return <OpcUa />;
//     case SubLinkId.flow_path:
//       return <FlowPath />;
//     case SubLinkId.pumps:
//       return <Pumps />;
//     case SubLinkId.sensors:
//       return <Sensors />;
//     default:
//       return <></>;
//   }
// };

const SidebarContent: FC = (): JSX.Element => {
  const {
    activeSubLink: { sidebar },
  } = useStore();

  if (sidebar) {
    return (
      <div className="c-sidebar__wrapper">
        <SidebarWrapper>{<sidebar.Content />}</SidebarWrapper>
      </div>
    );
  }

  return <></>;
};

export default SidebarContent;
